import styled from 'styled-components'

import { COMPANY_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'

type CompanyLinksProps = {
  padding: {
    pc: string
    sp?: string
  }
}

export const CompanyLinks = ({ padding }: CompanyLinksProps) => {
  return (
    <CompanyNaviListWrapper padding={padding}>
      <CompanyNaviList>
        {COMPANY_ROUTE.subdirectories.map(({ path, name, imagePath }) => (
          <li key={name}>
            <LinkCard link={path} title={name} imgPath={imagePath} />
          </li>
        ))}
      </CompanyNaviList>
    </CompanyNaviListWrapper>
  )
}

const CompanyNaviListWrapper = styled.div<Pick<CompanyLinksProps, 'padding'>>`
  margin: 0 auto;
  padding: ${({ padding }) => padding.pc};
  width: 1040px;

  @media screen and (max-width: 1047px) {
    padding: ${({ padding }) => padding.sp};
    width: 100%;

    display: ${({ padding }) => !padding.sp && 'none'};
  }
`

const CompanyNaviList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 66px 46px;

  @media screen and (max-width: 1047px) {
    justify-content: center;
    gap: 38px;

    li:nth-child(odd):last-child {
      margin-right: 388px;
    }
  }

  @media screen and (max-width: 700px) {
    li:nth-child(odd):last-child {
      margin-right: 0;
    }
  }
`
